import { useEffect } from "react";
import { motion } from "framer-motion";

export const useSeo = (title, description) => {
  useEffect(() => {
    document.title = title ? `${title} | Motive Press` : "Motive Press — Advancing Knowledge Across Disciplines";
    if (description) document.querySelector('meta[name="description"]')?.setAttribute("content", description);
  }, [title, description]);
};

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9, ease, delay }} className={className}>
      {children}
    </M>
  );
};

export const MaskLines = ({ lines, className = "", delay = 0.1, as = "h1" }) => {
  const Tag = as;
  return (
    <Tag className={className}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span className="block" initial={{ y: "105%" }} animate={{ y: "0%" }} transition={{ duration: 1.1, ease, delay: delay + i * 0.12 }}>
            {l}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const PageHeader = ({ eyebrow, title, intro, testid = "page-header" }) => (
  <section className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-16 lg:pt-24 pb-12 lg:pb-16" data-testid={testid}>
    {eyebrow && <motion.p className="eyebrow mb-6" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6 }}>{eyebrow}</motion.p>}
    <MaskLines lines={[title]} className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.02] max-w-4xl" />
    {intro && <Reveal delay={0.25}><p className="mt-8 max-w-2xl text-lg text-[var(--ink-muted)] leading-relaxed">{intro}</p></Reveal>}
  </section>
);

export const Marquee = ({ items }) => (
  <div className="marquee overflow-hidden border-y border-[var(--line)] py-6 bg-[var(--paper)]" data-testid="editorial-marquee" aria-label="Disciplines">
    <div className="marquee-track">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
          {items.map((t) => (
            <span key={t + k} className="flex items-center font-display italic text-3xl sm:text-5xl text-[var(--ink)] px-8 whitespace-nowrap">
              {t}<span className="ml-16 inline-block w-2.5 h-2.5 rounded-full bg-[var(--gold)]" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
